import React from 'react';
import { getMapImageUrl } from '../../utils/formatters';
import MatchDemosButton from '../common/MatchDemosButton';
import './MatchCard.css';

const MatchCard = ({ match, onClick, isLive }) => {
  const team1Won = !isLive && match.team1_score > match.team2_score;
  const team2Won = !isLive && match.team2_score > match.team1_score;
  const mapImageUrl = getMapImageUrl(match.map_image_url);

  const seriesType = (match.series_type || 'BO1').toUpperCase();
  const isSeries = seriesType !== 'BO1';
  const seriesMaps = Array.isArray(match.maps) ? match.maps : [];

  return (
    <div
      className={`match-card lift-card notched-card ${mapImageUrl ? 'has-map-image' : ''} ${isLive ? 'match-card-live' : ''}`}
      onClick={() => onClick && onClick(match.matchid)}
      style={mapImageUrl ? { '-map-bg': `url(${mapImageUrl})` } : {}}
    >
      <div className="match-card-overlay">
        <div className="match-map">
          {isLive && (
            <span className="match-card-live-badge">
              <span className="match-card-live-dot"></span>
              LIVE
            </span>
          )}
          {isSeries && (
            <span className="match-card-series-badge">{seriesType}</span>
          )}
          {match.league_info && (
            <span
              className="match-card-league-badge"
              title={`${match.league_info.league_name} — ${match.league_info.division_name}`}
            >
              🏅 {match.league_info.league_name}
            </span>
          )}
          <span className="map-name">
            {isSeries && seriesMaps.length > 0
              ? seriesMaps.map(m => m.mapname).join(' · ')
              : (match.mapname || 'Unknown Map')}
          </span>
          <span className="match-date">
            {new Date(match.start_time).toLocaleDateString('sv-SE')}
          </span>
          <div className="match-card-actions" onClick={(e) => e.stopPropagation()}>
            <MatchDemosButton
              mapDemos={match.map_demos}
              fallbackUrl={match.demo_url}
              hasDemo={match.has_demo}
              size="small"
            />
          </div>
        </div>
        <div className="match-teams">
          <div className={`team team-left ${team1Won ? 'winner' : ''}`}>
            <span className="team-name">{match.team1_name || 'Team 1'}</span>
            <span className="team-score">{match.team1_score}</span>
          </div>
          <div className="match-vs">VS</div>
          <div className={`team team-right ${team2Won ? 'winner' : ''}`}>
            <span className="team-score">{match.team2_score}</span>
            <span className="team-name">{match.team2_name || 'Team 2'}</span>
          </div>
        </div>
        {isSeries && seriesMaps.length > 0 && (
          <div className="match-card-map-scores">
            {seriesMaps.map((m, idx) => (
              <span key={idx} className="match-card-map-score">
                {m.mapname} {m.team1_score}-{m.team2_score}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MatchCard;
